module.exports = __webpack_public_path__ + "media/images/sort_desc-33be6b5cd626999ee02249702c812acc.png";